/**
 * CTA icon cycle: play once per pointer/focus enter, never reverse on leave.
 * After the slide finishes, the icon stays on the incoming copy while the
 * pointer remains over the button, then snaps back with transitions off.
 *
 * A wrapper with `data-cta-hover-scope` widens the pointer trigger to the
 * whole wrapper, and plays every cycling icon inside it.
 */
(function () {
  if (window.ctaIconCycleBound) return;
  window.ctaIconCycleBound = true;

  const reduceMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scopeOf = (target) =>
    target.closest &&
    (target.closest('[data-cta-hover-scope]') || target.closest('.has-cta-icon--cycle'));

  const iconsOf = (scope) =>
    scope.matches('.has-cta-icon--cycle')
      ? [...scope.querySelectorAll('.cta-icon')]
      : [...scope.querySelectorAll('.has-cta-icon--cycle .cta-icon')];

  const iconOf = (btn) => btn.querySelector('.cta-icon');

  const reset = (icon) => {
    icon.classList.add('is-resetting');
    icon.classList.remove('is-cycling');
    void icon.offsetWidth;
    icon.classList.remove('is-resetting');
    icon._busy = false;
    icon._done = false;
  };

  const play = (icon) => {
    if (!icon || icon._busy || reduceMotion()) return;
    icon._busy = true;
    icon._done = false;
    icon.classList.remove('is-resetting');
    void icon.offsetWidth;
    icon.classList.add('is-cycling');
  };

  const onEnd = (icon) => {
    icon._done = true;
    if (!icon._hovered) reset(icon);
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      const scope = scopeOf(event.target);
      if (!scope) return;
      if (scope.contains(event.relatedTarget)) return;
      iconsOf(scope).forEach((icon) => {
        icon._hovered = true;
        play(icon);
      });
    },
    true
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const scope = scopeOf(event.target);
      if (!scope) return;
      if (scope.contains(event.relatedTarget)) return;
      iconsOf(scope).forEach((icon) => {
        icon._hovered = false;
        if (icon._done) reset(icon);
      });
    },
    true
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const btn = event.target.closest && event.target.closest('.has-cta-icon--cycle');
      if (!btn) return;
      const icon = iconOf(btn);
      if (!icon) return;
      icon._hovered = true;
      play(icon);
    },
    true
  );

  document.addEventListener(
    'focusout',
    (event) => {
      const btn = event.target.closest && event.target.closest('.has-cta-icon--cycle');
      if (!btn) return;
      if (btn.contains(event.relatedTarget)) return;
      const icon = iconOf(btn);
      if (!icon) return;
      icon._hovered = false;
      if (icon._done) reset(icon);
    },
    true
  );

  document.addEventListener(
    'transitionend',
    (event) => {
      if (event.propertyName && event.propertyName !== 'transform') return;
      const img = event.target;
      if (!img.classList || !img.classList.contains('cta-icon__img--out')) return;
      const icon = img.closest('.cta-icon');
      if (!icon || !icon.classList.contains('is-cycling')) return;
      onEnd(icon);
    },
    true
  );
})();
